import { render, staticRenderFns } from "./ModalReviewDelete.vue?vue&type=template&id=e4480b68"
import script from "./ModalReviewDelete.vue?vue&type=script&lang=js"
export * from "./ModalReviewDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports